import {v4 as uuidv4} from 'uuid';
import {InvenTypeVo} from '../../common/shared/api/gateway/enums/InvenTypeVo.enum';
import {InvenResultVo} from '../../common/shared/api/nicolas/vo/inven/InvenResultVo.interface';
import {InvenList, Maybe, User} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSortOption} from './SortOption';

export function createInvenList({
  invenListResult,
  type,
  userInfo,
}: {
  invenListResult: InvenResultVo;
  type: InvenTypeVo;
  userInfo: Maybe<User>;
}): InvenList {
  const id = uuidv4();
  return {
    id,
    isEnd: invenListResult.is_end,
    list: invenListResult.list
      ? invenListResult.list.map(item =>
          createNormalListViewItem(userInfo, {
            ...(type === InvenTypeVo.Like
              ? {invenLikeItemSeriesDto: item}
              : type === InvenTypeVo.Paid
                ? {invenPaidItemSeriesDto: item}
                : {invenRecentItemSeriesDto: item}),
          })
        )
      : [],
    catOptList: invenListResult.cat_opt_list.map(opt =>
      createSortOption({sortOptVo: opt})
    ),
    selectedCatOpt: createSortOption({
      sortOptVo: invenListResult.selected_cat_opt,
    }),
    selectedSortOpt: createSortOption({
      sortOptVo: invenListResult.selected_sort_opt,
    }),

    sortOptList: invenListResult.sort_opt_list
      ? invenListResult.sort_opt_list.map(opt =>
          createSortOption({sortOptVo: opt})
        )
      : [],
    totalCount: invenListResult.total_count,
    displayAd:
      invenListResult.display_ad && createDisplayAd(invenListResult.display_ad),
  };
}
